import {apiUrl} from "../../../setting";

export const getServiceReportUrl = () => {
    return `${apiUrl}/v2/get-service-report`
}
export const getOpdReportUrl = () => {
    return `${apiUrl}/v2/get-opd-report`
}
export const getMedicineReportUrl = () => {
    return `${apiUrl}/v2/get-medicine-report`
}
export const getPaidReportUrl = () => {
    return `${apiUrl}/v2/get-paid-report`
}
export const getStockValuationUrl = () => {
    return `${apiUrl}/v2/get-stock-valuation`
}
export const getSummaryUrl = () => {
    return `${apiUrl}/v2/get-summary`
}
export const getVisitFollowupsUrl = () => {
    return `${apiUrl}/v2/get-visit-followups`
}
export const getAllBranchUrl = () => {
    return `${apiUrl}/v2/get-all-branch`
}